const deliveryConfirmationFR = {
    "view": {
        "table": {
            "title": "Liste Livrée",
            "columns": {
                "release": "Sortie",
                "upc": "Numéro UPC",
                "action": "Action",
                "status": "Statut",
                "deliveryDate": "Date de Livraison",
                "details": "Détails"
            },
            "label": {
                "statusDelivered": "LIVRÉ",
                "statusPartially": "PARTIELLEMENT",
                "statusUndelivered": "NON LIVRÉ",
                "ddexActionInsert": "INSÉRER",
                "ddexActionFullUpdate": "MISE À JOUR COMPLÈTE",
                "ddexActionMetadataUpdate": "MISE À JOUR MÉTA.",
                "ddexActionTakedown": "RETRAIT"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "button": {
                "open": "OUVRIR",
                "exportCSV": "Exporter CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Liste de Livraison des Magasins",
            "column": {
                "store": "Magasin",
                "additionalNote": "Notes Supplémentaires",
                "status": "Statut"
            },
            "label": {
                "statusDelivered": "LIVRÉ",
                "statusUndelivered": "NON LIVRÉ"
            },
            "button": {
                "exportCSV": "Exporter CSV"
            },
            "message": {
                "appleSubjectToQC": "Livré avec succès, sous réserve d'un contrôle QC supplémentaire par le personnel d'Apple Music.",
                "releaseDeliverySuccessfull": "La sortie a été livrée avec succès aux serveurs de {{dspName}}",
                "releaseDeliveryUnsuccessfull": "La livraison de la sortie a échoué pour {dspName}.",
                "noDeliveriesPossible": "Aucune livraison possible pour le moment"
            }
        }
    }
};

export default deliveryConfirmationFR;